module.exports = __webpack_public_path__ + "f114-bg-pop.png";